export default __webpack_public_path__ + "static/media/r200-1.0324040e.png";